import InputControl from '../InputControl/InputControl';
import { connect } from 'react-redux';
import { mapState } from './constants/store';
import React from 'react';
import { CyclePackageProps } from './interfaces';
import { useTranslation } from 'react-i18next';
import InteractiveButton from '../InteractiveButton/InteractiveButton';
import { ElementSize } from '../../types/element-size';
import { OpenReport } from '../Icons/OpenReport/OpenReport';

const CyclePackage: React.FC<CyclePackageProps> = ({ onSelectFile, packages, cycleName }) => {
  const { t } = useTranslation();

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onSelectFile(file);
    }
  };

  return (
    <div className="flex flex-col gap-4 c-cycle-package">
      <InputControl
        type="file"
        label={`${t('labels.uploadPackageForCycle')} ${cycleName}`}
        accept=".pdf,application/pdf"
        onChange={handleFileSelect}
      />

      <div className="mt-4">
        <h3 className="text-lg font-semibold mb-2">Package</h3>
        {(!packages || packages.length === 0) ? (
          <p className="text-gray-500">No package uploaded</p>
        ) : (
          <ul className='flex flex-col gap-y-2'>
            {packages.map((cyclePackage) => (
              <li key={cyclePackage.id} className="flex flex-col justify-between py-2 px-3 border rounded text-left">
                <p className='text-xs'><span className='text-primary'>Author:</span> {cyclePackage.creator}</p>
                <div className='flex flex-row justify-between'>
                  <span className='inline-block flex-auto truncate'>{cyclePackage.name}</span>
                  <InteractiveButton
                    className='hover:bg-white min-w-6 bg-white border-foggy-mist'
                    size={ElementSize.XXS}
                    as='a'
                    target="_blank"
                    rel="noopener noreferrer"
                    href={cyclePackage.file}
                    iconLeft={<OpenReport stroke='inherit' iconClassName='stroke-black' />}
                  />
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default connect(mapState, null)(CyclePackage);